import { render } from "./ImgSelector.vue?vue&type=template&id=55467f40&scoped=true"
import script from "./ImgSelector.vue?vue&type=script&lang=js"
export * from "./ImgSelector.vue?vue&type=script&lang=js"

import "./ImgSelector.vue?vue&type=style&index=0&id=55467f40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55467f40"]])

export default __exports__